import React from "react";
const Facebook = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <ellipse cx="12.7057" cy="12" rx="12.0338" ry="12" fill="white" />
    <path
      d="M10.7435 9.33333H9.23926V11.5H10.7435V18H13.2505V11.5H15.0556L15.2562 9.33333H13.2505V8.4125C13.2505 7.925 13.3508 7.70833 13.8021 7.70833H15.2562V5H13.3508C11.5457 5 10.7435 5.86667 10.7435 7.49167V9.33333Z"
      fill="black"
    />
  </svg>
);

export default Facebook;
